import { z } from 'zod';
import { appointment } from './appointment.res.dto';
import { nachversandAppointmentTypes } from './nachversand-booking-link.dto';
import { retrievalModeZodEnum } from '../../enum';

export const nachversandAppointmentQueryReqDto = z.object({
  type: z.enum(nachversandAppointmentTypes),
});
export type NachversandAppointmentQueryReqDto = z.infer<
  typeof nachversandAppointmentQueryReqDto
>;

export const nachversandAppointmentResDto = z.object({
  appointment,
  // An appointment is done once the kind's retrieval is settled: DISPATCHED,
  // RETURNED_READY_FOR_PICKUP, PICKED_UP or NO_FULFILLMENT.
  retrievalSettled: z.boolean(),
  // Postal or pickup fulfilment of this kind — a revoked eligibility flips MAIL to PICKUP.
  // null = no retrieval row for this kind yet.
  retrievalMode: retrievalModeZodEnum().nullable(),
});
export type NachversandAppointmentResDto = z.infer<
  typeof nachversandAppointmentResDto
>;
